import * as React from 'react';
import type { WhyUsExperience } from '../../types/whyus-landing';

interface ExperienceSectionProps {
  items: WhyUsExperience[];
}

export function ExperienceSection({ items }: ExperienceSectionProps) {
  return (
    <section className="whyus-experience">
      <style>{`
        .whyus-experience {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .whyus-experience-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .whyus-experience h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 40px;
          text-align: center;
        }
        .whyus-experience-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .whyus-exp-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          border: 1px solid #eee;
        }
        .whyus-exp-card .card-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .whyus-exp-card .card-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .whyus-exp-card-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .whyus-exp-card-text p {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        @media (max-width: 768px) {
          .whyus-experience-cards {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .whyus-experience h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-experience-inner">
        <h2>Obsesionados con tu experiencia</h2>
        <div className="whyus-experience-cards">
          {items.map((item) => (
            <div key={item.title} className="whyus-exp-card">
              <div className="card-icon"><i className={`fa ${item.icon}`} /></div>
              <div className="whyus-exp-card-text">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
